import styled from "@emotion/styled";
import { Button } from "react-aria-components";

/**
 * Base close-button for dialog content rendered inside a `Modal`. Positions
 * itself absolutely in the top-right corner so the dialog body's
 * `position: relative` parent contains it. Flavor-specific buttons extend
 * this to set their hit-target size / icon padding.
 */
export const DialogCloseButton = styled(Button)`
  position: absolute;
  top: 0.5rem /* 8/16 */;
  right: 0.5rem /* 8/16 */;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
`;
